import Cookies from 'js-cookie'

const TokenKey = 'Regulatory-Admin-Token'
const AccessTokenKey = 'Regulatory-Access-Token'
const FirmIdKey = 'Regulatory-Firm-Id'
const AgencyIdKey = 'Regulatory-Agency-Id'
const hostname = getBaseUrl()

export function getRegulatoryToken() {
  return Cookies.get(TokenKey, {domain: hostname})
}

export function getAccessToken() {
  return Cookies.get(AccessTokenKey, {domain: hostname})
}

export function getFirmId() {
  return Cookies.get(FirmIdKey, {domain: hostname})
}

export function getAgencyId() {
  return Cookies.get(AgencyIdKey, {domain: hostname})
}

function getBaseUrl() {
  let hostname = window.location.hostname
  return  ['localhost', '127.0.0.1', '192.168.0.10', 'dev6.afrank.cn'].findIndex(_host => _host === hostname) !== -1?hostname: hostname.substring(hostname.indexOf('.'))
}



//////////////////
// WEBPACK FOOTER
// ./build/auth.js
// module id = null
// module chunks = 